import { type Referral } from './referrals-store';

/**
 * SCRUM-93 — pure logic for the Teller Nudge Banner, kept out of the component
 * file so the component module only exports a component (react-refresh rule).
 */

/** Days-pending threshold: > 48h. The model is day-granular, so > 2 days. */
export const STALE_PENDING_DAYS = 2;

/** Count of a teller's OWN referrals still pending beyond the 48h window. */
export function stalePendingCount(
  referrals: readonly Referral[],
  displayName: string | undefined,
): number {
  if (!displayName) return 0;
  return referrals.filter(
    (r) =>
      r.status === 'pending' &&
      r.tellerName === displayName &&
      r.submittedDaysAgo > STALE_PENDING_DAYS,
  ).length;
}
